import React, { useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../shared/context/auth-context';

import Input from '../../shared/components/formElements/Input';
import Button from '../../shared/components/formElements/Button';
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_MINLENGTH,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NUMERIC,
  VALIDATOR_SPECIAL_CHARACHTER
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import './Customers.css';
import Capitalize from '../../shared/components/UIElements/Capitalize ';
import { useEffect } from 'react';


const NewCustomer = () => {
  const inputRef = useRef(null);
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      name: {
        value: '',
        isValid: false
      },
      lastname: {
        value: '',
        isValid: false
      },
      phone: {
        value: '',
        isValid: false
      },
      address: {
        value: '',
        isValid: true,
      }
    },
    false
  );

  const history = useHistory();

  const placeSubmitHandler = async event => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+'/customers/new',
        'POST',
        JSON.stringify({
          name: Capitalize(formState.inputs.name.value),
          lastname: Capitalize(formState.inputs.lastname.value),
          phone: formState.inputs.phone.value,
          address: Capitalize(formState.inputs.address.value),
        }),
        { 'Content-Type': 'application/json',
        Authorization: 'Bearer '+ auth.token }
      );
      history.push('/customers');
    } catch (err) {}
  };

  useEffect( () => {
    inputRef.current.focus();
  },[])

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <form className="customer-form" onSubmit={placeSubmitHandler}>
       {isLoading && <LoadingSpinner asOverlay />}
        <h2 style={{textAlign: 'center'}}>Create new Customer</h2>
        {/* <input  ref={inputRef}/> */}
        <Input
            id="name"
            element="input"
            type="text"
            label="Name"
            validators={[VALIDATOR_REQUIRE(),  VALIDATOR_SPECIAL_CHARACHTER()]}
            errorText="Please enter a name"
            onInput={inputHandler}
            inputRef = {inputRef}
        />
        <Input
            id="lastname"
            element="input"
            type="text"
            label="Last Name"
            validators={[VALIDATOR_REQUIRE(),  VALIDATOR_SPECIAL_CHARACHTER()]}
            errorText="Please enter a last name"
            onInput={inputHandler}
        />
        <Input
            id="phone"
            element="input"
            type="number"
            label="Phone Number"
            validators={[VALIDATOR_MINLENGTH(10), VALIDATOR_MAXLENGTH(10), VALIDATOR_NUMERIC()]}
            errorText="Please enter a valid phone number (XXXYYYZZZZ)."
            onInput={inputHandler}
        />
        <Input
            type="text"
            id="address"
            element="input"
            label="Address"
            validators={[VALIDATOR_NOT_REQUIRE(), VALIDATOR_SPECIAL_CHARACHTER() , VALIDATOR_MAXLENGTH(30)]}
            onInput={inputHandler}
            errorText="Please enter a valid address (Max 30 Characters)."
        />
        <Button type="submit" disabled={!formState.isValid} >
            ADD CUSTOMER
        </Button>
        <Button inverse to="/customers">
            CANCEL
        </Button>
        </form>
    </React.Fragment>
  );
};

export default NewCustomer;
